<script setup lang="ts">
import { RouterLink } from 'hybridly/vue'

const { user } = useUser()
</script>

<template>
	<ui-sidebar-menu>
		<ui-sidebar-menu-item>
			<ui-dropdown-menu>
				<ui-dropdown-menu-trigger as-child>
					<ui-sidebar-menu-button
						size="lg"
						class="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
					>
						<ui-avatar class="size-8 rounded-lg">
							<ui-avatar-initials :name="user.name" class="rounded-lg" />
						</ui-avatar>
						<div class="grid flex-1 text-left text-sm leading-tight">
							<span class="truncate font-semibold">{{ user.name }}</span>
							<span class="truncate text-xs">{{ user.email }}</span>
						</div>
						<i-ph-caret-down-bold class="ml-auto size-4" />
					</ui-sidebar-menu-button>
				</ui-dropdown-menu-trigger>
				<ui-dropdown-menu-content
					class="w-[var(--radix-dropdown-menu-trigger-width)] min-w-56 rounded-lg"
					side="bottom"
					align="end"
					:side-offset="4"
				>
					<ui-dropdown-menu-label class="p-0 font-normal">
						<div class="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
							<ui-avatar class="size-8 rounded-lg">
								<ui-avatar-initials :name="user.name" class="rounded-lg" />
							</ui-avatar>

							<div class="grid flex-1 text-left text-sm leading-tight">
								<span class="truncate font-semibold">{{ user.name }}</span>
								<span class="truncate text-xs">{{ user.email }}</span>
							</div>
						</div>
					</ui-dropdown-menu-label>
					<ui-dropdown-menu-separator />
					<ui-dropdown-menu-group>
						<ui-dropdown-menu-item :as="RouterLink" :href="route('user-profile-information.show')">
							<i-ph-user-bold />
							{{ t('app.buttons.account') }}
						</ui-dropdown-menu-item>
					</ui-dropdown-menu-group>
					<ui-dropdown-menu-separator />
					<ui-dropdown-menu-item :as="RouterLink" :href="route('logout')" method="post">
						<i-ph-sign-out-bold />
						{{ t('app.buttons.sign_out') }}
					</ui-dropdown-menu-item>
				</ui-dropdown-menu-content>
			</ui-dropdown-menu>
		</ui-sidebar-menu-item>
	</ui-sidebar-menu>
</template>
